import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Lauuch from "../pages/Lauuch";
import ClaimList from "../Components/Claim/ClaimList";
import { _InfinityFactoryContractGetAllDataByAddress } from "../Services/Web3Connection";
import Footer from "../Components/Footer";
import Loading from "../Components/Animation/Loading/Loading";
const Claim = (props) => {
  const [FactoryContract, setFactoryContract] = useState(null);
  useEffect(async () => {
    let data = await _InfinityFactoryContractGetAllDataByAddress();
    setFactoryContract(data);
    // console.log(data);
  }, []);

  return (
    <>
      <img
        className="infinitypageimg"
        src={process.env.PUBLIC_URL + "/assets/images/bg1.jpg"}
        alt="..."
      />
      <div className="bgimg">
        <Header Connect={props.Connect} setConnect={props.setConnect} />
        <div className="container">
          <Lauuch />
          <div
            class="row mt-5"
            style={{
              justifyContent: "center",
            }}
          >
            {FactoryContract === null ? (
              <div
              // style={{
              //   color: "#ff832e",
              //   textAlign: "center",
              //   position: "relative",
              // }}
              >
                <Loading />
              </div>
            ) : (
              // <Loading />
              <div
                className="container cardlist "
                style={{ gridTemplateColumns: "none" }}
              >
                <ClaimList data={FactoryContract} />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Claim;
